import { CategoriesTable } from '@/components/features/categories'

export const Categories = () => {
  return <CategoriesTable />
}
